<template>
  <v-row>
    <v-col cols="12">
      <v-form ref="formUser">
        <base-card>
          <v-card-title>Registrar Usuarios </v-card-title>
          <v-card-text>
            <v-row>
              <v-col
                cols="12"
                sm="4"
              >
                <v-select
                  ref="cliente"
                  v-model="dataUser.cliente"
                  :items="detailClients"
                  item-text="name"
                  item-value="id"
                  label="Compania"
                  prepend-inner-icon="mdi-sitemap"
                  :rules="formRules"
                  :error-messages="errorMessages"
                  required
                />
              </v-col>
              <v-col
                cols="12"
                sm="4"
              >
                <v-text-field
                  ref="name"
                  v-model="dataUser.name"
                  label="Nombre"
                  prepend-inner-icon="mdi-account-tie"
                  clearable
                  :rules="formRules"
                  :error-messages="errorMessages"
                  required
                />
              </v-col>

              <v-col
                cols="12"
                sm="4"
              >
                <v-text-field
                  ref="email"
                  v-model="dataUser.email"
                  label="Correo"
                  prepend-inner-icon="mdi-email"
                  clearable
                  :rules="emailRules"
                  :error-messages="errorMessages"
                  required
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                sm="4"
              >
                <v-text-field
                  ref="password"
                  v-model="dataUser.password"
                  label="Contraseña"
                  prepend-inner-icon="mdi-account-key"
                  clearable
                  :rules="passwordRules"
                  :error-messages="errorMessages"
                  required
                />
                <password-strength :password="dataUser.password || ''" />
              </v-col>
              <v-col
                cols="12"
                sm="4"
              >
                <v-select
                  ref="rol"
                  v-model="dataUser.rol"
                  :items="typeRol"
                  item-text="textRol"
                  item-value="valueRol"
                  label="Rol"
                  prepend-inner-icon="mdi-account-network"
                  :rules="formRules"
                  :error-messages="errorMessages"
                  required
                />
              </v-col>
              <v-col
                cols="12"
                sm="4"
              >
                <v-btn
                  class="ma-2"
                  style="background-color:rgb(204 33 40);color:white !important"
                  @click="validateUser"
                >
                  Registrar
                </v-btn>
              </v-col>
              <v-alert
                v-show="successAlert"
                type="success"
                text
              >
                {{ msgSuccessAlert }}
              </v-alert>
            </v-row>
            <v-row
              v-if="progress === true"
              class="fill-height"
              align-content="center"
              justify="center"
            >
              <v-col cols="6">
                <v-col
                  class="text-subtitle-1 text-center"
                  cols="12"
                >
                  Registrando Usuario
                </v-col>
                <v-progress-linear
                  color="red darken-4"
                  indeterminate
                  rounded
                  height="6"
                />
              </v-col>
            </v-row>
          </v-card-text>
        </base-card>
      </v-form>
    </v-col>
  </v-row>
</template>

<script>
  import { getListRoles } from '@/data/listRoles'
  import PasswordStrength from '@/components/PasswordStrength'
  import { passwordRules } from '@/utils/passwordRules'
  import { emailRules } from '@/utils/emailRules'

  export default {
    name: 'RegistrarUsers',
    components: {
      'password-strength': PasswordStrength,
    },

    data () {
      return {
        passwordRules,
        emailRules,
        dataUser: {},
        rol: '',
        email: '',
        password: '',
        cliente: '',
        name: '',
        typeRol: [],
        errorMessages: '',
        formHasErrors: null,
        successAlert: false,
        progress: false,
        msgSuccessAlert: 'Usuario registrado exitosamente',
        detailsClient: {},
        detailsClients: {},
        formRules: [
          (v) => !!v || 'Este campo es requerido',
        ],
      }
    },
    computed: {
      detailClients () {
        return this.$store.state.clients.listClients.Mensaje
      },
      statusResponseUser () {
        return this.$store.state.users.statusResponseUser
      },
    },
    async created () {
      this.getListClients();
      await this.loadRoles();
    },
    watch:
      {
        statusResponseUser () {
          if (this.statusResponseUser === true) {
            this.generateAlertSuccess()
            this.formHasErrors = null
            this.$store.dispatch('users/setStatusResponse', false)
          }
        },
      },
    methods: {
      async getListClients () {
        await this.$store.dispatch('clients/getListClients')
      },
      generateAlertSuccess () {
        this.successAlert = true
        this.$store.dispatch('users/getListUsers')
        this.clearForm()
        this.getListClients();
        setTimeout(() => {
          this.successAlert = false
        }, 3000)
      },
      clearForm () {
        this.$refs.formUser.reset()
      },
      validateUser () {
        this.formHasErrors = !this.$refs.formUser.validate()

        if (this.formHasErrors) return

        this.sendUser()
      },
      async sendUser () {
        this.progress = true
        try {
          await this.$store.dispatch('users/insertUser', {
            ...this.dataUser,
          })
        } finally {
          this.progress = false
        }
      },
      async loadRoles() {
        try {
          this.typeRol = await getListRoles();
        } catch (error) {
          console.error("❌ Error al cargar roles:", error);
        }
      },
    },
  }
</script>
